module.exports = "pegasus/assets/tech/medium/5.jpg";